import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styled from '@emotion/styled'
import tokens from '../../design/design-tokens/tokens'

export const DIVIDER_VARIANT_DEFAULT = 'DEFAULT'
export const DIVIDER_VARIANT_LIGHT = 'LIGHT'

const StyledDivider = styled.hr`
  margin: 0;
  border-top: 1px solid
    ${({ variant }) =>
      variant === DIVIDER_VARIANT_DEFAULT
        ? `#d5dadf` // TODO: sostituire token - geyser, athensGray
        : `#e6e9ec`};
  ${({ negativeMarginX }) => negativeMarginX !== 0 && `margin: 0 -${negativeMarginX}px`}
`

export const Divider = ({ variant, negativeMarginX, className }) => {
  return (
    <StyledDivider
      variant={variant}
      negativeMarginX={negativeMarginX}
      className={classnames(className)}
    />
  )
}

/** @params
 * negativeMarginX: positive integer substracted to the horizontal margin
 */
Divider.defaultProps = {
  variant: DIVIDER_VARIANT_DEFAULT,
  negativeMarginX: 0
}

Divider.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf([DIVIDER_VARIANT_DEFAULT, DIVIDER_VARIANT_LIGHT]),
  negativeMarginX: PropTypes.number
}
